import apiClient from '@utils/apiClient';
import {
    CorporationListRes,
    CorporationListReq,
    CorporationInfoRes,
    CorporationInfo,
    CorporationPassUpdateReq,
    CorporationUpdateReq,
    CorporationAddReq,
} from './type.ts';
import { ApiResult } from '@/api/common/type';

export const api = {
    /**
     * 대행사목록
     * @param param
     */
    corporationList: async (
        param: CorporationListReq,
    ): Promise<CorporationListRes> => {
        const response = await apiClient.post<CorporationListRes>(
            '/api/v1/corporation/list',
            param,
        );
        return response.data;
    },
    /**
     * 대행사상세
     * @param userIdx
     */
    corporationInfo: async (userIdx: number): Promise<CorporationInfo> => {
        const response = await apiClient.get<CorporationInfoRes>(
            `/api/v1/corporation/${userIdx}`,
        );
        return response.data.data;
    },
    /**
     * 대행사 API 키발급
     * @param userIdx
     */
    corporationApiKeyReissue: async (userIdx: number): Promise<ApiResult> => {
        const response = await apiClient.get<ApiResult>(
            `/api/v1/corporation/reissue/${userIdx}`,
        );
        return response.data;
    },
    /**
     * 대행사 비밀번호 갱신
     * @param param
     */
    corporationPassUpdate: async (
        param: CorporationPassUpdateReq,
    ): Promise<ApiResult> => {
        const response = await apiClient.put<ApiResult>(
            '/api/v1/corporation/password/update',
            param,
        );
        return response.data;
    },
    /**
     * 대행사 정보갱신
     * @param param
     */
    corporationUpdate: async (
        param: CorporationUpdateReq,
    ): Promise<ApiResult> => {
        const response = await apiClient.put<ApiResult>(
            '/api/v1/corporation/update',
            param,
        );
        return response.data;
    },

    /**
     * 대행사 정보삭제
     * @param userIdx
     */
    corporationDelete: async (userIdx: number): Promise<ApiResult> => {
        const response = await apiClient.delete<ApiResult>(
            `/api/v1/corporation/delete/${userIdx}`,
        );
        return response.data;
    },

    /**
     * 대행사 정보등록
     * @param param
     */
    corporationAdd: async (param: CorporationAddReq): Promise<ApiResult> => {
        const response = await apiClient.post<ApiResult>(
            '/api/v1/corporation/add',
            param,
        );
        return response.data;
    },
};
